<template>
  <div v-if="inputId">
    <custom-select
      v-model="selectedModel"
      :options="options"
      :input-id="inputId"
      :clearable="false"
      label="title"
      :value="selectedModel?.value"
      clear-search-on-select="true"
      :placeholder="placeholder"
      @input="onChange"
    ></custom-select>
    <input
      name="direction"
      type="hidden"
      :value="selectedValue"
    />
  </div>
  <div v-else>
    <packman-loader size="15" />
  </div>
</template>

<script>
import sharedComponentsMessages from '../sharedComponentsMessages';
import CustomSelect from './custom-select.vue';
import PackmanLoader from './packman-loader.vue';

export default {
  name: 'tag-release-sort-direction-selector',
  components: { CustomSelect, PackmanLoader },
  data() {
    return {
      selectedModel: null,
      selectedValue: null,
      options: []
    };
  },
  props: {
    inputId: {
      type: String,
      default: null
    }
  },
  methods: {
    onChange() {
      this.selectedValue = this.selectedModel?.value;
      this.$router.push({
        query: {
          ...this.$route.query,
          direction: this.selectedValue
        }
      });
    }
  },
  watch: {
    '$route.query.sort'() {
      this.$router.push({ query: { ...this.$route.query, direction: undefined } });
      this.updateOptions();
    }
  },
  computed: {
    placeholder() {
      return this.$route.query.sort
        ? this.$t('tag_release_sort_direction_placeholder')
        : this.$t('tag_release_sort_criteria_placeholder');
    }
  },
  mounted() {
    this.updateOptions();
  },
  methods: {
    onChange() {
      this.selectedValue = this.selectedModel?.value;
      this.$router.push({
        query: {
          ...this.$route.query,
          direction: this.selectedValue
        }
      });
    },
    updateSelectedOption() {
      if (this.$route.query.sort === 'TIME') {
        if (this.$route.query?.direction === 'ASC') {
          this.selectedModel = this.options ? this.options[1] : null;
          this.selectedValue = this.selectedModel ? this.selectedModel.value : null;
        } else if (this.$route.query?.direction === 'DESC') {
          this.selectedModel = this.options ? this.options[0] : null;
          this.selectedValue = this.selectedModel ? this.selectedModel.value : null;
        } else if (this.$route.query?.sort) {
          this.selectedModel = this.options ? this.options[0] : null;
          this.selectedValue = this.selectedModel ? this.selectedModel.value : null;
        }
      } else if (this.$route.query.sort === 'NAME') {
        if (this.$route.query?.direction === 'ASC') {
          this.selectedModel = this.options ? this.options[0] : null;
          this.selectedValue = this.selectedModel ? this.selectedModel.value : null;
        } else if (this.$route.query?.direction === 'DESC') {
          this.selectedModel = this.options ? this.options[1] : null;
          this.selectedValue = this.selectedModel ? this.selectedModel.value : null;
        } else if (this.$route.query?.sort) {
          this.selectedModel = this.options ? this.options[0] : null;
          this.selectedValue = this.selectedModel ? this.selectedModel.value : null;
        }
      }
      if (this.$route.query.direction !== this.selectedModel?.value)
        this.$router.push({
          query: { ...this.$route.query, direction: this.selectedModel?.value }
        });
    },
    updateOptions() {
      if (this.$route.query.sort === 'TIME') {
        this.options = [
          {
            title: this.$t('tag_release_sort_time_desc'),
            value: 'DESC'
          },
          {
            title: this.$t('tag_release_sort_time_asc'),
            value: 'ASC'
          }
        ];
      } else if (this.$route.query.sort === 'NAME') {
        this.options = [
          {
            title: this.$t('tag_release_sort_name_desc'),
            value: 'ASC'
          },
          {
            title: this.$t('tag_release_sort_name_asc'),
            value: 'DESC'
          }
        ];
      } else {
        this.options = [];
        this.selectedModel = null;
        this.selectedValue = null;
      }
      this.updateSelectedOption();
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>


